import styled from "styled-components";

export const Container = styled.div`
  align-items: center;
  background-color: ${(props) => props.theme.colors.white};
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  padding: 4rem 2.5rem;
  width: 88rem;

  p {
    ${(props) => `
      color: ${
        props.theme.colors.blackTextTitle + props.theme.transparencies.p58
      };
      font-family: ${props.theme.fontFamilies.primaryFont};
    `}
    font-size: 1.6rem;
    font-weight: 500;
    line-height: 2.4rem;
    margin-top: 2rem;
    padding: 0 1rem;
    text-align: center;
  }

  h1 {
    ${(props) => `
      color: ${props.theme.colors.blackTextTitle};
      font-family: ${props.theme.fontFamilies.primaryFont};
    `}
    text-align: center;
    font-size: 2rem;
    font-weight: 800;
    margin-bottom: 0;
  }

  p {
    ${(props) => `
      color: ${
        props.theme.colors.blackTextTitle + props.theme.transparencies.p58
      };
      font-family: ${props.theme.fontFamilies.primaryFont};
    `}
    font-size: 1.6rem;
    font-weight: 500;
    line-height: 2.4rem;
    margin-top: 2rem;
    padding: 0 1rem;
    text-align: center;
  }
  div {
    ${(props) => `
      font-family: ${props.theme.fontFamilies.primaryFont};
    `}
  }
`;

export const MainButton = styled.button`
  ${(props) => `
    background-color: ${props.theme.colors.primaryBlue};
    font-family: ${props.theme.fontFamilies.primaryFont};
    color: ${props.theme.colors.white};
  `}
  align-items: center;
  border-radius: 8px;
  border: none;
  cursor: pointer;
  display: flex;
  font-size: 1.5em;
  font-weight: 700;
  justify-content: center;
  margin-top: 2rem;
  min-height: 5.6rem;
  width: 78rem;
`;

interface IButtonConfigurate {
  backgroundColor?: string;
  fontSize?: string;
  fontWeight?: string | number;
  marginTop?: string;
  minHeight?: string;
  width?: string;
}
export const ButtonConfigurate = styled.button<IButtonConfigurate>`
  ${(props) => `
  background-color: ${
    props.backgroundColor
      ? props.backgroundColor
      : props.theme.colors.primaryBlue
  };
  font-family: ${props.theme.fontFamilies.primaryFont};
  color: ${props.color ? props.color : props.theme.colors.white};
  font-size: ${props.fontSize ? props.fontSize : "1.5em"};
  font-weight: ${props.fontWeight ? props.fontWeight : "700"};
  margin-top:${props.marginTop ? props.marginTop : "2rem"};
  min-height:${props.minHeight ? props.minHeight : "5.6rem"};
  width:${props.width ? props.width : "32.4rem"};
  `}
  align-items: center;
  border-radius: 8px;
  border: none;
  cursor: pointer;
  display: flex;
  justify-content: center;
`;

export const ContainerMessages = styled.div`
  overflow-y: auto;
  overflow-x: auto;
  background: #ffffff;
  max-height: 25.7rem;

  width: 75.9rem;
  box-shadow: inset 0px 0px 9px rgba(0, 0, 0, 0.25);
  padding: 2rem;

  &::-webkit-scrollbar {
    width: 10px;
  }
  &::-webkit-scrollbar-thumb {
    background: #c6c8ce;
    border-radius: 10px;
  }
  &::-webkit-scrollbar-track {
    background: #ffffff;
  }
  &::-webkit-scrollbar-corner {
    background-color: #ffffff;
  }
`;
